export const translations: Record<string, Record<string, string>> = {
  en: {
    home: "Home",
    products: "Products",
    ourStory: "Our Story",
    blogs: "Blogs",
    orders: "Orders",
    profile: "Profile",
    cart: "Cart",
    login: "Login",
    register: "Register",
    logout: "Logout",
    addToCart: "Add to Cart",
    shopHarvest: "Shop the Harvest",
    viewAll: "View All",
    viewMoreBlogs: "View More Blogs",
    exploreRanges: "Explore Our Handpicked Ranges",
    localFarmsText: "Straight from local Tamil farms to your home",
    secureCheckout: "Secure Checkout",
    deliveryAddress: "Delivery Address",
    firstName: "First Name",
    lastName: "Last Name",
    completeAddress: "Complete Address",
    pincode: "PIN Code (Checked for restriction)",
    city: "City",
    phoneVerification: "Phone Verification",
    verifiedPhone: "Phone number verified",
    verifyRequired: "Verification is required before place order. Enter your phone number below:",
    sendOtp: "Send OTP",
    verifyOtp: "Verify",
    enterOtp: "6-digit OTP code",
    useTestOtp: "Use test OTP code:",
    continueDelivery: "Continue to Delivery",
    back: "Back",
    continuePayment: "Continue to Payment",
    selectDeliverySlot: "Select Delivery Slot",
    estSurcharge: "Estimated delivery surcharge",
    ecoPackaging: "Eco-Friendly Packaging",
    ecoDesc: "100% plastic-free, biodegradable elements. (+₹10)",
    securePayment: "Secure Payment Gateway",
    paymentEncrypted: "All transactions are encrypted and secure.",
    razorpayGateway: "Razorpay Checkout Gateway",
    razorpayDesc: "You will be redirected to Razorpay's secure portal to authorize your purchase using Card, UPI, or Netbanking.",
    pay: "Pay",
    orderSummary: "Order Summary",
    qty: "Qty",
    cartSubtotal: "Cart Subtotal",
    gstTax: "GST Tax",
    deliveryFeeSlot: "Delivery Fee & Slot Surcharge",
    ecoPackagingFee: "Eco Packaging",
    totalToPay: "Total to Pay",
    orderPlaced: "Order Placed!",
    orderSuccessDesc: "Thank you for shopping organic. Your order has been registered and is currently being processed by our farms.",
    orderNumber: "Order Number",
    totalPaid: "Total Paid",
    backToStorefront: "Back to Storefront",
    myOrdersHistory: "My Orders history",
    filters: "Filters",
    search: "Search",
    findProduct: "Find a product...",
    category: "Category",
    maxPrice: "Max Price",
    clearFilters: "Clear Filters",
    sortBy: "Sort By",
    showing: "Showing",
    organicItems: "organic items",
    noProductsFound: "No products found",
    noProductsDesc: "Try adjusting your filters or search query.",
    salemNonVegTitle: "Salem Special Meat & Seafood",
    salemNonVegDesc: "Antibiotic-free local Salem specials cut fresh to your order instructions.",
    showNonVegToggle: "Show Non-Veg Specials",
    nonVegFilterPageTitle: "Salem Special Meats",
    nonVegFilterPageDesc: "100% fresh, hygienic local cuts restricted to Salem pincodes.",
    cookingInstructions: "Cooking Instructions",
    addCookingInstructions: "Add custom instructions (e.g., bone pieces only, skinless)",
    cutSizeGuide: "Cut Size Guide & Prep Instructions",
    productBenefits: "Product Benefits",
    healthyRecipe: "Healthy Recipe",
    viewFullRecipe: "View Full Recipe Steps",
    customerReviews: "Customer Reviews",
    verifiedPurchase: "Verified Purchase",
    leaveReview: "Leave a Product Review",
    rating: "Rating",
    reviewText: "Review Details",
    submitReview: "Submit Review",
    selectVariant: "Select Variant",
    lowStockWarning: "Only {stock} left in stock! Order soon.",
    outOfStock: "Out of Stock - Temporarily unavailable",
    guaranteedQuality: "100% Quality Guaranteed",
    freeExpressDelivery: "Free Express Delivery",
    pinnedOrderText: "Pinned Order: #",
    all: "All",
    organicApples: "Organic Apples",
    freshAvocados: "Fresh Avocados",
    organicCarrots: "Organic Carrots",
    organicSpinach: "Organic Spinach"
  },
  ta: {
    home: "முகப்பு",
    products: "தயாரிப்புகள்",
    ourStory: "எங்கள் கதை",
    blogs: "வலைப்பதிவுகள்",
    orders: "ஆர்டர்கள்",
    profile: "சுயவிவரம்",
    cart: "கூடை",
    login: "உள்நுழைவு",
    register: "பதிவு",
    logout: "வெளியேறு",
    addToCart: "கூடையில் சேர்க்கவும்",
    shopHarvest: "அறுவடையை வாங்குங்கள்",
    viewAll: "அனைத்தையும் காட்டு",
    viewMoreBlogs: "மேலும் வலைப்பதிவுகள்",
    exploreRanges: "எங்கள் தேர்ந்தெடுத்த தயாரிப்புகள்",
    localFarmsText: "உள்ளூர் தமிழ் பண்ணைகளிலிருந்து நேரடியாக உங்கள் வீட்டிற்கு",
    secureCheckout: "பாதுகாப்பான செக்அவுட்",
    deliveryAddress: "விநியோக முகவரி",
    firstName: "முதல் பெயர்",
    lastName: "கடைசி பெயர்",
    completeAddress: "முழு முகவரி",
    pincode: "அஞ்சல் குறியீடு (பின்கோடு)",
    city: "நகரம்",
    phoneVerification: "தொலைபேசி சரிபார்ப்பு",
    verifiedPhone: "தொலைபேசி எண் சரிபார்க்கப்பட்டது",
    verifyRequired: "ஆர்டர் செய்வதற்கு முன் சரிபார்ப்பு தேவை. உங்கள் எண்ணை உள்ளிடவும்:",
    sendOtp: "OTP அனுப்பு",
    verifyOtp: "சரிபார்",
    enterOtp: "6-இலக்க OTP குறியீடு",
    useTestOtp: "தேர்வு செய்ய வேண்டிய OTP குறியீடு:",
    continueDelivery: "டெலிவரிக்கு தொடரவும்",
    back: "முந்தையது",
    continuePayment: "கட்டண பகுதிக்கு தொடரவும்",
    selectDeliverySlot: "டெலிவரி நேரத்தை தேர்வு செய்யவும்",
    estSurcharge: "மதிப்பிடப்பட்ட டெலிவரி கட்டணம்",
    ecoPackaging: "சுற்றுச்சூழல் நட்பு பேக்கேஜிங்",
    ecoDesc: "100% நெகிழி இல்லாத மக்கும் பேக்கேஜிங். (+₹10)",
    securePayment: "பாதுகாப்பான கட்டண நுழைவாயில்",
    paymentEncrypted: "அனைத்து பரிவர்த்தனைகளும் குறியாக்கம் செய்யப்பட்டு பாதுகாப்பாக உள்ளன.",
    razorpayGateway: "ரேஸோர்பே கட்டண நுழைவாயில்",
    razorpayDesc: "அட்டை, UPI அல்லது நெட்பேங்கிங் மூலம் உங்கள் கட்டணத்தை அங்கீகரிக்க ரேஸோர்பே பாதுகாப்பான பக்கத்திற்கு அனுப்பப்படுவீர்கள்.",
    pay: "பணம் செலுத்துக ₹",
    orderSummary: "ஆர்டர் சுருக்கம்",
    qty: "அளவு",
    cartSubtotal: "கூடையின் மொத்த மதிப்பு",
    gstTax: "ஜிஎஸ்டி வரி",
    deliveryFeeSlot: "டெலிவரி & கூடுதல் கட்டணம்",
    ecoPackagingFee: "சுற்றுச்சூழல் பேக்கேஜிங்",
    totalToPay: "செலுத்த வேண்டிய மொத்த தொகை",
    orderPlaced: "ஆர்டர் செய்யப்பட்டது!",
    orderSuccessDesc: "இயற்கை தயாரிப்புகளை வாங்கியதற்கு நன்றி. உங்கள் ஆர்டர் பெறப்பட்டு பண்ணைகளில் தயாராகி வருகிறது.",
    orderNumber: "ஆர்டர் எண்",
    totalPaid: "மொத்தம் செலுத்தப்பட்டது",
    backToStorefront: "முகப்புப் பக்கத்திற்கு",
    myOrdersHistory: "என் ஆர்டர் வரலாறு",
    filters: "வடிகட்டிகள்",
    search: "தேடு",
    findProduct: "தயாரிப்பைத் தேடு...",
    category: "வகை",
    maxPrice: "அதிகபட்ச விலை",
    clearFilters: "வடிகட்டிகளை நீக்கு",
    sortBy: "வரிசைப்படுத்து",
    showing: "காட்டுகிறது",
    organicItems: "இயற்கை பொருட்கள்",
    noProductsFound: "தயாரிப்புகள் எதுவும் கிடைக்கவில்லை",
    noProductsDesc: "உங்கள் வடிகட்டிகளை மாற்றி மீண்டும் முயற்சிக்கவும்.",
    salemNonVegTitle: "சேலம் பண்ணை-புதிய அசைவம் & கடல் உணவு",
    salemNonVegDesc: "ரசாயனங்கள் இல்லாத சேலம் ஸ்பெஷல் இறைச்சி உங்கள் விருப்பப்படி வெட்டி தரப்படும்.",
    showNonVegToggle: "அசைவ உணவுகளைக் காட்டு",
    nonVegFilterPageTitle: "சேலம் ஸ்பெஷல் இறைச்சிகள்",
    nonVegFilterPageDesc: "100% புதிய, சுகாதாரமான சேலம் பின்கோடுகளுக்கு மட்டுமேயான விநியோகம்.",
    cookingInstructions: "சமையல் வழிமுறைகள்",
    addCookingInstructions: "குறிப்புகள் சேர்க்கவும் (எ.கா. தோல் நீக்கியது, சிறிய துண்டுகள்)",
    cutSizeGuide: "துண்டு அளவுகள் & சமையல் குறிப்புகள்",
    productBenefits: "தயாரிப்பு நன்மைகள்",
    healthyRecipe: "ஆரோக்கியமான செய்முறை",
    viewFullRecipe: "முழு செய்முறையை காண்க",
    customerReviews: "வாடிக்கையாளர் மதிப்புரைகள்",
    verifiedPurchase: "சரிபார்க்கப்பட்ட வாங்குதல்",
    leaveReview: "மதிப்புரை எழுதவும்",
    rating: "மதிப்பீடு",
    reviewText: "மதிப்புரை விவரங்கள்",
    submitReview: "மதிப்புரையை சமர்ப்பி",
    selectVariant: "அளவை தேர்வு செய்",
    lowStockWarning: "இருப்பில் {stock} மட்டுமே உள்ளது! உடனே ஆர்டர் செய்யவும்.",
    outOfStock: "இருப்பில் இல்லை - தற்காலிகமாக கிடைக்கவில்லை",
    guaranteedQuality: "100% தரம் உத்தரவாதம்",
    freeExpressDelivery: "இலவச விரைவு விநியோகம்",
    pinnedOrderText: "இணைக்கப்பட்ட ஆர்டர்: #",
    all: "அனைத்தும்",
    organicApples: "இயற்கை ஆப்பிள்கள்",
    freshAvocados: "புதிய வெண்ணெய் பழம்",
    organicCarrots: "இயற்கை கேரட்",
    organicSpinach: "இயற்கை கீரை"
  },
  hi: {
    home: "होम",
    products: "उत्पाद",
    ourStory: "हमारी कहानी",
    blogs: "ब्लॉग",
    orders: "आदेश",
    profile: "प्रोफाइल",
    cart: "कार्ट",
    login: "लॉगिन",
    register: "पंजीकरण",
    logout: "लॉगआउट",
    addToCart: "कार्ट में जोड़ें",
    shopHarvest: "फसल खरीदें",
    viewAll: "सभी देखें",
    viewMoreBlogs: "अधिक ब्लॉग देखें",
    exploreRanges: "हमारे चुने हुए उत्पाद",
    localFarmsText: "सीधे तमिल खेतों से आपके घर तक",
    secureCheckout: "सुरक्षित चेकआउट",
    deliveryAddress: "वितरण पता",
    firstName: "पहला नाम",
    lastName: "अंतिम नाम",
    completeAddress: "पूरा पता",
    pincode: "पिन कोड",
    city: "शहर",
    phoneVerification: "फ़ोन सत्यापन",
    verifiedPhone: "फ़ोन नंबर सत्यापित",
    verifyRequired: "आदेश देने से पहले सत्यापन आवश्यक है। अपना फ़ोन नंबर दर्ज करें:",
    sendOtp: "OTP भेजें",
    verifyOtp: "सत्यापित करें",
    enterOtp: "6-अंकीय ओटीपी",
    useTestOtp: "परीक्षण ओटीपी कोड:",
    continueDelivery: "वितरण पर जारी रखें",
    back: "पीछे",
    continuePayment: "भुगतान पर जारी रखें",
    selectDeliverySlot: "वितरण समय स्लॉट चुनें",
    estSurcharge: "अनुमानित वितरण शुल्क",
    ecoPackaging: "पर्यावरण-अनुकूल पैकेजिंग",
    ecoDesc: "100% प्लास्टिक मुक्त जैव-अपघटनीय पैकेजिंग। (+₹10)",
    securePayment: "सुरक्षित भुगतान गेटवे",
    paymentEncrypted: "सभी लेनदेन सुरक्षित और एन्क्रिप्टेड हैं।",
    razorpayGateway: "रेज़रपे चेकआउट गेटवे",
    razorpayDesc: "आपको कार्ड, यूपीआई या नेटबैंकिंग का उपयोग करके भुगतान अधिकृत करने के लिए रेज़रपे के सुरक्षित पोर्टल पर पुनर्निर्देशित किया जाएगा।",
    pay: "भुगतान करें ₹",
    orderSummary: "आदेश सारांश",
    qty: "मात्रा",
    cartSubtotal: "कार्ट उप-योग",
    gstTax: "GST कर",
    deliveryFeeSlot: "वितरण शुल्क और स्लॉट शुल्क",
    ecoPackagingFee: "इको पैकेजिंग",
    totalToPay: "कुल भुगतान राशि",
    orderPlaced: "आदेश दिया गया!",
    orderSuccessDesc: "ऑर्गेनिक खरीदारी के लिए धन्यवाद। आपका आदेश पंजीकृत कर लिया गया है और हमारे खेतों द्वारा तैयार किया जा रहा है।",
    orderNumber: "ऑर्डर नंबर",
    totalPaid: "कुल भुगतान",
    backToStorefront: "स्टोरफ्रंट पर वापस जाएं",
    myOrdersHistory: "मेरा ऑर्डर इतिहास",
    filters: "फ़िल्टर",
    search: "खोजें",
    findProduct: "उत्पाद खोजें...",
    category: "श्रेणी",
    maxPrice: "अधिकतम मूल्य",
    clearFilters: "फ़िल्टर साफ़ करें",
    sortBy: "इसके अनुसार क्रमबद्ध करें",
    showing: "दिखा रहा है",
    organicItems: "जैविक उत्पाद",
    noProductsFound: "कोई उत्पाद नहीं मिला",
    noProductsDesc: "अपने फ़िल्टर या खोज क्वेरी को समायोजित करने का प्रयास करें।",
    salemNonVegTitle: "सलेम स्पेशल मीट और सीफूड",
    salemNonVegDesc: "एंटीबायोटिक-मुक्त स्थानीय सलेम विशिष्ट उत्पाद आपके निर्देशानुसार ताज़ा कटे हुए।",
    showNonVegToggle: "मांसाहारी उत्पाद दिखाएं",
    nonVegFilterPageTitle: "सलेम स्पेशल मीट",
    nonVegFilterPageDesc: "100% ताज़ा, स्वच्छ स्थानीय कट केवल सलेम पिन कोड के लिए सीमित।",
    cookingInstructions: "पकाने के निर्देश",
    addCookingInstructions: "विशेष निर्देश जोड़ें (जैसे, त्वचा रहित, छोटे टुकड़े)",
    cutSizeGuide: "कट आकार गाइड और निर्देश",
    productBenefits: "उत्पाद के लाभ",
    healthyRecipe: "स्वस्थ नुस्खा",
    viewFullRecipe: "पूरी रेसिपी देखें",
    customerReviews: "ग्राहक समीक्षाएं",
    verifiedPurchase: "सत्यापित खरीद",
    leaveReview: "उत्पाद की समीक्षा लिखें",
    rating: "रेटिंग",
    reviewText: "समीक्षा विवरण",
    submitReview: "समीक्षा जमा करें",
    selectVariant: "वेरिएंट चुनें",
    lowStockWarning: "स्टॉक में केवल {stock} बचे हैं! जल्द ही ऑर्डर करें।",
    outOfStock: "स्टॉक समाप्त - अस्थायी रूप से अनुपलब्ध",
    guaranteedQuality: "100% गुणवत्ता की गारंटी",
    freeExpressDelivery: "मुफ़्त एक्सप्रेस डिलीवरी",
    pinnedOrderText: "पिन किया गया ऑर्डर: #",
    all: "सभी",
    organicApples: "जैविक सेब",
    freshAvocados: "ताज़ा एवोकैडो",
    organicCarrots: "जैविक गाजर",
    organicSpinach: "जैविक पालक"
  },
  kn: {
    home: "ಮನೆ",
    products: "ಉತ್ಪನ್ನಗಳು",
    ourStory: "ನಮ್ಮ ಕಥೆ",
    blogs: "ಬ್ಲಾಗ್‌ಗಳು",
    orders: "ಆರ್ಡರ್ಸ್",
    profile: "ಪ್ರೊಫೈಲ್",
    cart: "ಕಾರ್ಟ್",
    login: "ಲಾಗಿನ್",
    register: "ನೋಂದಣಿ",
    logout: "ಲಾಗ್ ಔಟ್",
    addToCart: "ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಿ",
    shopHarvest: "ಬೆಳೆಯನ್ನು ಖರೀದಿಸಿ",
    viewAll: "ಎಲ್ಲವನ್ನೂ ವೀಕ್ಷಿಸಿ",
    viewMoreBlogs: "ಹೆಚ್ಚಿನ ಬ್ಲಾಗ್‌ಗಳು",
    exploreRanges: "ನಮ್ಮ ಆಯ್ಕೆ ಮಾಡಿದ ಉತ್ಪನ್ನಗಳು",
    localFarmsText: "ಸ್ಥಳೀಯ ತಮಿಳು ಫಾರ್ಮ್‌ಗಳಿಂದ ನೇರವಾಗಿ ನಿಮ್ಮ ಮನೆಗೆ",
    secureCheckout: "ಸುರಕ್ಷಿತ ಚೆಕ್ಔಟ್",
    deliveryAddress: "ವಿತರಣಾ ವಿಳಾಸ",
    firstName: "ಮೊದಲ ಹೆಸರು",
    lastName: "ಕೊನೆಯ ಹೆಸರು",
    completeAddress: "ಪೂರ್ಣ ವಿಳಾಸ",
    pincode: "ಪಿನ್ ಕೋಡ್",
    city: "ನಗರ",
    phoneVerification: "ದೂರವಾಣಿ ಪರಿಶೀಲನೆ",
    verifiedPhone: "ದೂರವಾಣಿ ಸಂಖ್ಯೆ ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
    verifyRequired: "ಆರ್ಡರ್ ಮಾಡುವ ಮೊದಲು ಪರಿಶೀಲನೆ ಅಗತ್ಯವಿದೆ. ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ:",
    sendOtp: "OTP ಕಳುಹಿಸಿ",
    verifyOtp: "ಪರಿಶೀಲಿಸಿ",
    enterOtp: "6-ಅಂಕಿಯ OTP ಕೋಡ್",
    useTestOtp: "ಪರೀಕ್ಷಾ OTP ಕೋಡ್:",
    continueDelivery: "ಡೆಲಿವರಿ ಪ್ರಕ್ರಿಯೆಗೆ ಮುಂದುವರಿಯಿರಿ",
    back: "ಹಿಂದಕ್ಕೆ",
    continuePayment: "ಪಾವತಿಗೆ ಮುಂದುವರಿಯಿರಿ",
    selectDeliverySlot: "ಡೆಲಿವರಿ ಸಮಯವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    estSurcharge: "ಅಂದಾಜು ಡೆಲಿವರಿ ಶುಲ್ಕ",
    ecoPackaging: "ಪರಿಸರ ಸ್ನೇಹಿ ಪ್ಯಾಕೇಜಿಂಗ್",
    ecoDesc: "100% ಪ್ಲಾಸ್ಟಿಕ್ ಮುಕ್ತ ಪ್ಯಾಕೇಜಿಂಗ್. (+₹10)",
    securePayment: "ಸುರಕ್ಷಿತ ಪಾವತಿ ಗೇಟ್‌ವೇ",
    paymentEncrypted: "ಎಲ್ಲಾ ವಹಿವಾಟುಗಳು ಸುರಕ್ಷಿತ ಮತ್ತು ಎನ್‌ಕ್ರಿಪ್ಟ್ ಆಗಿವೆ.",
    razorpayGateway: "ರೇಜರ್‌ಪೇ ಚೆಕ್ಔಟ್ ಗೇಟ್‌ವೇ",
    razorpayDesc: "ಪಾವತಿಯನ್ನು ದೃಢೀಕರಿಸಲು ನಿಮ್ಮನ್ನು ರೇಜರ್‌ಪೇ ಸುರಕ್ಷಿತ ಪುಟಕ್ಕೆ ಮರುನಿರ್ದೇಶಿಸಲಾಗುತ್ತದೆ.",
    pay: "ಪಾವತಿಸಿ ₹",
    orderSummary: "ಆರ್ಡರ್ ಸಾರಾಂಶ",
    qty: "ಪ್ರಮಾಣ",
    cartSubtotal: "ಕಾರ್ಟ್ ಒಟ್ಟು ಮೊತ್ತ",
    gstTax: "GST ತೆರಿಗೆ",
    deliveryFeeSlot: "ಡೆಲಿವರಿ ಮತ್ತು ಸ್ಲಾಟ್ ಶುಲ್ಕ",
    ecoPackagingFee: "ಪರಿಸರ ಪ್ಯಾಕೇಜಿಂಗ್ ಶುಲ್ಕ",
    totalToPay: "ಪಾವತಿಸಬೇಕಾದ ಒಟ್ಟು ಮೊತ್ತ",
    orderPlaced: "ಆರ್ಡರ್ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    orderSuccessDesc: "ಖರೀದಿಸಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು. ನಿಮ್ಮ ಆರ್ಡರ್ ಸ್ವೀಕರಿಸಲ್ಪಟ್ಟಿದೆ ಮತ್ತು ನಮ್ಮ ಫಾರ್ಮ್‌ಗಳಿಂದ ಪ್ಯಾಕ್ ಮಾಡಲಾಗುತ್ತಿದೆ.",
    orderNumber: "ಆರ್ಡರ್ ಸಂಖ್ಯೆ",
    totalPaid: "ಒಟ್ಟು ಪಾವತಿಸಿದ ಮೊತ್ತ",
    backToStorefront: "ಮನೆ ಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ",
    myOrdersHistory: "ನನ್ನ ಆರ್ಡರ್ ಇತಿಹಾಸ",
    filters: "ಫಿಲ್ಟರ್‌ಗಳು",
    search: "ಹುಡುಕು",
    findProduct: "ಉತ್ಪನ್ನವನ್ನು ಹುಡುಕಿ...",
    category: "ವರ್ಗ",
    maxPrice: "ಗರಿಷ್ಠ ಬೆಲೆ",
    clearFilters: "ಫಿಲ್ಟರ್‌ಗಳನ್ನು ತೆರವುಗೊಳಿಸಿ",
    sortBy: "ವಿಂಗಡಿಸು",
    showing: "ತೋರಿಸುತ್ತಿದೆ",
    organicItems: "ಸಾವಯವ ವಸ್ತುಗಳು",
    noProductsFound: "ಯಾವುದೇ ಉತ್ಪನ್ನ ಕಂಡುಬಂದಿಲ್ಲ",
    noProductsDesc: "ದಯವಿಟ್ಟು ಫಿಲ್ಟರ್‌ಗಳನ್ನು ಬದಲಾಯಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    salemNonVegTitle: "ಸೇಲಂ ಫಾರ್ಮ್-ಫ್ರೆಶ್ ಮಾಂಸ ಮತ್ತು ಸಮುದ್ರಾಹಾರ",
    salemNonVegDesc: "ಆಂಟಿಬಯೋಟಿಕ್ ಮುಕ್ತ ತಾಜಾ ಮಾಂಸ ನಿಮ್ಮ ಅಗತ್ಯಕ್ಕೆ ತಕ್ಕಂತೆ ಕತ್ತರಿಸಿ ನೀಡಲಾಗುವುದು.",
    showNonVegToggle: "ಮಾಂಸಾಹಾರಿ ಉತ್ಪನ್ನಗಳನ್ನು ತೋರಿಸು",
    nonVegFilterPageTitle: "ಸೇಲಂ ಸ್ಪೆಷಲ್ ಮಾಂಸಗಳು",
    nonVegFilterPageDesc: "100% ತಾಜಾ, ನೈರ್ಮಲ್ಯಯುತ ಸೇಲಂ ಪಿನ್ ಕೋಡ್‌ಗಳಿಗೆ ಮಾತ್ರ ವಿತರಣೆ.",
    cookingInstructions: "ಅಡುಗೆ ಸೂಚನೆಗಳು",
    addCookingInstructions: "ಸೂಚನೆಗಳನ್ನು ಸೇರಿಸಿ (ಉದಾಹರಣೆಗೆ, ಚರ್ಮರಹಿತ, ಸಣ್ಣ ತುಂಡುಗಳು)",
    cutSizeGuide: "ತುಂಡು ಗಾತ್ರ ಮತ್ತು ಸೂಚನೆಗಳು",
    productBenefits: "ಉತ್ಪನ್ನದ ಪ್ರಯೋಜನಗಳು",
    healthyRecipe: "ಆರೋಗ್ಯಕರ ಅಡುಗೆ ವಿಧಾನ",
    viewFullRecipe: "ಪೂರ್ಣ ವಿಧಾನವನ್ನು ವೀಕ್ಷಿಸಿ",
    customerReviews: "ಗ್ರಾಹಕರ ವಿಮರ್ಶೆಗಳು",
    verifiedPurchase: "ಪರಿಶೀಲಿಸಿದ ಖರೀದಿ",
    leaveReview: "ವಿಮರ್ಶೆ ಬರೆಯಿರಿ",
    rating: "ರೇಟಿಂಗ್",
    reviewText: "ವಿಮರ್ಶೆ ವಿವರಗಳು",
    submitReview: "ವಿಮರ್ಶೆಯನ್ನು ಸಲ್ಲಿಸಿ",
    selectVariant: "ವೇರಿಯಂಟ್ ಆಯ್ಕೆಮಾಡಿ",
    lowStockWarning: "ಸ್ಟಾಕ್‌ನಲ್ಲಿ ಕೇವಲ {stock} ಉಳಿದಿವೆ! ಬೇಗ ಆರ್ಡರ್ ಮಾಡಿ.",
    outOfStock: "ಖಾಲಿಯಾಗಿದೆ - ತಾತ್ಕಾಲಿಕವಾಗಿ ಲಭ್ಯವಿಲ್ಲ",
    guaranteedQuality: "100% ಗುಣಮಟ್ಟ ಖಾತರಿ",
    freeExpressDelivery: "ಉಚಿತ ಎಕ್ಸ್‌ಪ್ರೆಸ್ ಡೆಲಿವರಿ",
    pinnedOrderText: "ಪಿನ್ ಮಾಡಿದ ಆರ್ಡರ್: #",
    all: "ಎಲ್ಲವೂ",
    organicApples: "ಸಾವಯವ ಸೇಬುಗಳು",
    freshAvocados: "ತಾಜಾ ಆವಕಾಡೊ",
    organicCarrots: "ಸಾವಯವ ಕ್ಯಾರೆಟ್",
    organicSpinach: "ಸಾವಯವ ಪಾಲಕ್"
  },
  ml: {
    home: "ഹോം",
    products: "ഉൽപ്പന്നങ്ങൾ",
    ourStory: "ഞങ്ങളുടെ കഥ",
    blogs: "ബ്ലോഗുകൾ",
    orders: "ഓർഡറുകൾ",
    profile: "പ്രൊഫൈൽ",
    cart: "കാർട്ട്",
    login: "ലോഗിൻ",
    register: "രജിസ്റ്റർ",
    logout: "ലോഗ് ഔട്ട്",
    addToCart: "കാർട്ടിലേക്ക് ചേർക്കുക",
    shopHarvest: "വിളവെടുപ്പ് വാങ്ങുക",
    viewAll: "എല്ലാം കാണുക",
    viewMoreBlogs: "കൂടുതൽ ബ്ലോഗുകൾ",
    exploreRanges: "ഞങ്ങൾ തിരഞ്ഞെടുത്ത ഉൽപ്പന്നങ്ങൾ",
    localFarmsText: "തമിഴ് ഫാമുകളിൽ നിന്ന് നേരിട്ട് നിങ്ങളുടെ വീട്ടിലേക്ക്",
    secureCheckout: "സുരക്ഷിത ചെക്ക്ഔട്ട്",
    deliveryAddress: "ഡെലിവറി വിലാസം",
    firstName: "ആദ്യ നാമം",
    lastName: "അവസാന നാമം",
    completeAddress: "പൂർണ്ണ വിലാസം",
    pincode: "പിൻ കോഡ്",
    city: "നഗരം",
    phoneVerification: "ഫോൺ വെരിഫിക്കേഷൻ",
    verifiedPhone: "ഫോൺ നമ്പർ വെരിഫൈ ചെയ്തു",
    verifyRequired: "ഓർഡർ ചെയ്യുന്നതിന് മുമ്പ് ഫോൺ നമ്പർ വെരിഫിക്കേഷൻ ആവശ്യമാണ്. നമ്പർ നൽകുക:",
    sendOtp: "OTP അയയ്ക്കുക",
    verifyOtp: "വെരിഫൈ ചെയ്യുക",
    enterOtp: "6-അക്ക OTP കോഡ്",
    useTestOtp: "പരീക്ഷിക്കേണ്ട OTP കോഡ്:",
    continueDelivery: "ഡെലിവറിയിലേക്ക് തുടരുക",
    back: "പിന്നിലേക്ക്",
    continuePayment: "പേയ്‌മെന്റിലേക്ക് തുടരുക",
    selectDeliverySlot: "ഡെലിവറി സമയം തിരഞ്ഞെടുക്കുക",
    estSurcharge: "ഡെലിവറി ചാർജ്",
    ecoPackaging: "പരിസ്ഥിതി സൗഹൃദ പാക്കേജിംഗ്",
    ecoDesc: "100% പ്ലാസ്റ്റിക് രഹിത പാക്കേജിംഗ്. (+₹10)",
    securePayment: "സുരക്ഷിത പേയ്‌മെന്റ് ഗേറ്റ്‌വേ",
    paymentEncrypted: "എല്ലാ ഇടപാടുകളും പൂർണ്ണമായും സുരക്ഷിതമാണ്.",
    razorpayGateway: "റേസർപേ പേയ്‌മെന്റ് ഗേറ്റ്‌വേ",
    razorpayDesc: "പേയ്‌മെന്റ് വിജയകരമാക്കാൻ റേസർപേ സുരക്ഷിത പേജിലേക്ക് റീഡയറക്ട് ചെയ്യപ്പെടും.",
    pay: "പണം അടയ്ക്കുക ₹",
    orderSummary: "ഓർഡർ ചുരുക്കം",
    qty: "എണ്ണം",
    cartSubtotal: "കാർട്ട് മൊത്തം തുക",
    gstTax: "ജിഎസ്ടി നികുതി",
    deliveryFeeSlot: "ഡെലിവറി & സ്ലോട്ട് ചാർജ്",
    ecoPackagingFee: "ഇക്കോ പാക്കേജിംഗ് ചാർജ്",
    totalToPay: "ആകെ അടയ്ക്കേണ്ട തുക",
    orderPlaced: "ഓർഡർ വിജയകരമായി പൂർത്തിയായി!",
    orderSuccessDesc: "ഓർഗാനിക് ഉൽപ്പന്നങ്ങൾ വാങ്ങിയതിന് നന്ദി. ഓർഡർ ലഭിച്ചു, ഫാമുകളിൽ നിന്നും തയ്യാറാക്കിവരുന്നു.",
    orderNumber: "ഓർഡർ നമ്പർ",
    totalPaid: "ആകെ അടച്ചത്",
    backToStorefront: "ഹോം പേജിലേക്ക്",
    myOrdersHistory: "എന്റെ ഓർഡർ ചരിത്രം",
    filters: "ഫിൽട്ടറുകൾ",
    search: "തിരയുക",
    findProduct: "ഉൽപ്പന്നം തിരയുക...",
    category: "വിഭാഗം",
    maxPrice: "പരമാവധി വില",
    clearFilters: "ഫിൽട്ടറുകൾ മായ്ക്കുക",
    sortBy: "ക്രമീകരിക്കുക",
    showing: "കാണിക്കുന്നത്",
    organicItems: "ജൈവ ഉൽപ്പന്നങ്ങൾ",
    noProductsFound: "ഉൽപ്പന്നങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
    noProductsDesc: "നിങ്ങളുടെ ഫിൽട്ടറുകൾ മാറ്റി വീണ്ടും ശ്രമിക്കുക.",
    salemNonVegTitle: "സേലം ഫാം-ഫ്രഷ് ഇറച്ചിയും കടൽ വിഭവങ്ങളും",
    salemNonVegDesc: "ആൻറിബയോട്ടിക് വിമുക്തമായ പുതിയ ഇറച്ചി നിങ്ങളുടെ നിർദ്ദേശാനുസരണം കട്ട് ചെയ്തു നൽകുന്നു.",
    showNonVegToggle: "മാംസാഹാര ഉൽപ്പന്നങ്ങൾ കാണിക്കുക",
    nonVegFilterPageTitle: "സേലം സ്പെഷ്യൽ ഇറച്ചികൾ",
    nonVegFilterPageDesc: "100% ഫ്രഷ്, ശുചിത്വമുള്ള ഇറച്ചി സേലം പിൻ കോഡുകളിൽ മാത്രം ഡെലിവറി ചെയ്യപ്പെടുന്നു.",
    cookingInstructions: "പാചക നിർദ്ദേശങ്ങൾ",
    addCookingInstructions: "നിർദ്ദേശങ്ങൾ ചേർക്കുക (ഉദാഹരണത്തിന്, ചർമ്മമില്ലാത്തത്, ചെറിയ കഷണങ്ങൾ)",
    cutSizeGuide: "കട്ടിങ് അളവുകളും പാചക രീതിയും",
    productBenefits: "ഉൽപ്പന്ന ഗുണങ്ങൾ",
    healthyRecipe: "ആരോഗ്യകരമായ പാചകക്കൂട്ട്",
    viewFullRecipe: "മുഴുവൻ രീതിയും കാണുക",
    customerReviews: "ഉപഭോക്തൃ അവലോകനങ്ങൾ",
    verifiedPurchase: "വെരിഫൈഡ് പർച്ചേസ്",
    leaveReview: "അവലോകനം എഴുതുക",
    rating: "റേറ്റിംഗ്",
    reviewText: "അവലോകന വിവരങ്ങൾ",
    submitReview: "അവലോകനം സമർപ്പിക്കുക",
    selectVariant: "വേരിയന്റ് തിരഞ്ഞെടുക്കുക",
    lowStockWarning: "സ്റ്റോക്കിൽ ഇനി {stock} എണ്ണം മാത്രം! ഉടൻ ഓർഡർ ചെയ്യുക.",
    outOfStock: "സ്റ്റോക്ക് തീർന്നു - താൽക്കാലികമായി ലഭ്യമല്ല",
    guaranteedQuality: "100% ഗുണനിലവാരം ഉറപ്പ്",
    freeExpressDelivery: "സൗജന്യ എക്സ്പ്രസ് ഡെലിവറി",
    pinnedOrderText: "പിൻ ചെയ്ത ഓർഡർ: #",
    all: "എല്ലാം",
    organicApples: "ഓർഗാനിക് ആപ്പിളുകൾ",
    freshAvocados: "ഫ്രഷ് അവോക്കാഡോ",
    organicCarrots: "ഓർഗാനിക് ക്യാരറ്റ്",
    organicSpinach: "ഓർഗാനിക് ചീര"
  }
};
